// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"9bcda71f","159":"051e9f1f","364":"572399cb","647":"d9de312c","746":"324ae7af","787":"bf75b174"}[chunkId] + ".chunk.js";
};